import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class InspectionPresenter extends EntityPresenter {
  static urn = 'inspection-logs'
  static key = 'inspection-log'

  static navOptions(key = 'inspection-logs') {
    const routes = {
      "inspection-logs": {
        icon: 'family_history',
        pageRoutes: ['inspection_log'],
        title: 'Журнал обхода'
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(InspectionPresenter)
